<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <div class="col-md-12 bg-white">
          <v-toolbar color="#01579B" class="top-hero6" dark flat>
            <v-toolbar-title>Manage Snapshots</v-toolbar-title>
          </v-toolbar>

          <v-form>
            <div
              class="p-4 max-w-2xl flex justify-center gap-4 align-center text-center"
            >
              <v-text-field
                v-model="name"
                :counter="30"
                label="Name"
                required
              ></v-text-field>

              <v-text-field
                v-model="numberSnap"
                :counter="3"
                label="Number"
                required
              ></v-text-field>

              <v-btn :loading="loading" small color="success" @click="saveSnap">
                Save
              </v-btn>
            </div>
          </v-form>

          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Number</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="snap in snaps" :key="snap.id">
                  <td>
                    <v-text-field v-model="snap.name"></v-text-field>
                  </td>
                  <td>
                    <v-text-field v-model="snap.number"></v-text-field>
                  </td>
                  <td>
                    <v-btn
                      :loading="loading1"
                      @click="updateSnap(snap)"
                      x-small
                      color="info"
                    >
                      Update
                    </v-btn>

                    <v-btn
                      :loading="loading2"
                      @click="removeSnap(snap.id)"
                      class="ml-2"
                      x-small
                      color="error"
                    >
                      Delete
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
export default {
  data() {
    return {
      name: "",
      numberSnap: "",
      snaps: [],
      loading: false,
      loading1: false,
      loading2: false
    };
  },

  created() {
    this.getSnapshots();
  },

  methods: {
    saveSnap() {
      this.loading = true;
      window.axios
        .post("/api/saveStat", {
          numberSnap: this.numberSnap,
          name: this.name
        })
        .then(() => {
          this.numberSnap = "";
          this.name = "";
          this.getSnapshots();
          this.loading = false;
        });
    },

    updateSnap(snap) {
      this.loading1 = true;
      window.axios
        .post("/api/updateStat/" + snap.id, {
          name: snap.name,
          numberSnap: snap.number
        })
        .then(() => {
          this.getSnapshots();
          this.loading1 = false;
        });
    },

    removeSnap(id) {
      this.loading2 = true;
      window.axios.delete("/api/removeSnap/" + id).then(() => {
        this.getSnapshots();
        this.loading2 = false;
      });
    },

    getSnapshots() {
      window.axios.get("/api/getStats").then(res => {
        this.snaps = res.data;
      });
    }
  }
};
</script>
